// src/lib/amplify-config.ts
"use client";

import { Amplify } from 'aws-amplify';

let isConfigured = false;

/**
 * Configura Amplify Auth para trabajar con Cognito User Pool.
 * CRÍTICO: ssr: false es requerido para static export de Next.js.
 * Esta función es idempotente - puede llamarse múltiples veces sin efectos secundarios.
 */
export function configureAmplify(): void {
  if (isConfigured) return;

  const userPoolId = process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID;
  const userPoolClientId = process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID;

  if (!userPoolId || !userPoolClientId) {
    console.warn(
      'Amplify Auth: Missing NEXT_PUBLIC_COGNITO_USER_POOL_ID or NEXT_PUBLIC_COGNITO_CLIENT_ID'
    );
    return;
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          username: true,
          email: true,
        },
      },
    },
  }, { ssr: false }); // CRÍTICO: ssr: false para static export

  isConfigured = true;
}
